import React, { useState } from 'react';
import { Swiper, SwiperSlide, Autoplay, Pagination, TypeSwiper } from '../../services/ImportsSwiper';
import { Props } from './interfaces';
import './SliderLive.scss';
import './SliderLive-media.scss';
import PaginationBlock from '../Pagination/Pagination';

import { GetTypeNews } from '../../services/GlobalFunctions';
import { EnumUrlsPages } from '../../services/Enum';
import {Link} from "../Link/Link";

const SliderLive = ({ slides }: Props) => {
  const [numActiveSlide, setNumActiveSlide] = useState(1);

  const Changed = (current: TypeSwiper) => setNumActiveSlide(current.realIndex + 1);

  const [slider, setSlider] = useState<TypeSwiper>();
  const settings = {
    autoplay: false,
      speed: 500,
      loop: true,
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      onSlideChange: Changed,
      className: 'slider-live',
      spaceBetween: 20,
    };

    const prevSlide = () => {
      if (slider) {
        slider.slidePrev(500, false);
      }
    };
    const nextSlide = () => {
      if (slider) {
        slider.slideNext(500, false);
      }
    };

    const gradient = 'linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 50%)';

    return slides.length ? (
      <Swiper {...settings} onInit={(slider: TypeSwiper) => setSlider(slider)}>
        {slides.map(({uri, title, date, link, linkOut, image, imageFullwidth, type}, i) => (
          <SwiperSlide key={i}>
            <div className="slider-live__content">
              {linkOut ? (
                <a
                  href={link}
                  target="_blank"
                  className="slider-live__new"
                  style={{backgroundImage: `${gradient}, url(${imageFullwidth})`}}
                  key={i}
                >
                  <CardContent title={title} date={date} type={type}/>
                </a>
              ) : (
                <Link
                  to={uri}
                  className="slider-live__new"
                  style={{backgroundImage: `${gradient}, url(${imageFullwidth})`}}
                  key={i}
                >
                  <CardContent title={title} date={date} type={type}/>
                </Link>
              )}
            </div>
          </SwiperSlide>
        ))}

        <div className="slider-live__dots">
          <PaginationBlock current={numActiveSlide} all={slides.length}/>
          <div className="slider-live__arrow slider-live__arrow_prev" onClick={prevSlide}></div>
          <div className="slider-live__arrow slider-live__arrow_next" onClick={nextSlide}></div>
        </div>
      </Swiper>
    ) : null;
};

export default SliderLive;

const CardContent = ({ title, date, type }: { title: string; date: string; type: string }) => {
  return (
    <>
      <p className="slider-live__new-type">{GetTypeNews(type)}</p>
      <div>
        <h3 className="slider-live__new-title">{title}</h3>
        <p className="slider-live__new-date">{date}</p>
      </div>
    </>
  );
};


